import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  IMessageResponseDto,
  ICreateSubscriptionPriceDto,
  ISubscriptionPricesRespDto,
  IDefaultSubscriptionPricesRespDto,
  IOptionalSubscriptionPriceRespDto,
  IOptionalSubscriptionPricesDto,
  IUpdateSubscriptionPriceDto,
} from 'src/types'

class SubscriptionPriceService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getPrices(params?: {}) {
    return this.get<ISubscriptionPricesRespDto>('subscriptions/prices', { params })
  }

  getOptionalPrices(params: IOptionalSubscriptionPricesDto) {
    return this.get<IOptionalSubscriptionPriceRespDto>('subscriptions/prices/optional', {
      params,
    })
  }

  getDefaultPrices() {
    return this.get<IDefaultSubscriptionPricesRespDto>('subscriptions/prices/default')
  }

  createPrice(dto: ICreateSubscriptionPriceDto) {
    return this.post<IMessageResponseDto, ICreateSubscriptionPriceDto>('subscriptions/prices', dto)
  }

  updatePrice(id: string, dto: IUpdateSubscriptionPriceDto) {
    return this.put<IMessageResponseDto, IUpdateSubscriptionPriceDto>(
      `subscriptions/prices/${id}`,
      dto,
    )
  }

  removePrices(ids: string[]) {
    return this.delete<IMessageResponseDto>(`subscriptions/prices`, { data: { ids } })
  }
}

export const subscriptionPriceService = new SubscriptionPriceService()
export default SubscriptionPriceService
